module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Love Under Fire")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch003#copyright-information",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#acknowledgment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgment")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#the-poems",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Poems")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#waking-up",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waking Up")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#vampires-of-the-light",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vampires of the Light")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#office-training",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Office Training")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#leaving",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leaving")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#just-a-young-girl",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just a Young Girl")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-happy-one",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Happy One")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#my-name-is-anne",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Name Is Anne")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#between",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Between")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#muse-of-erudition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muse of Erudition")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-waves",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Waves")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#seaweed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seaweed")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#the-unicorn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unicorn")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#jerusalem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jerusalem")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#catwalk-season",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catwalk Season")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#mary-mary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary, Mary")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#am",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5am")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#my-ladys-invitation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Lady’s Invitation")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#forever-a-woman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forever a Woman")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#friends",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friends")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0